import { Box } from '@mui/material'
import { DateTime } from 'luxon'
import moment from 'moment'

type DisplayDateProps = {
  date: any
  viewType: 'local' | 'actual'
  timeZone: string
}

const DisplayDate = ({ date, viewType, timeZone }: DisplayDateProps) => {
  const returnValue = () => {
    switch (viewType) {
      case 'actual':
        return DateTime.fromISO(moment(date).toISOString())
          .setZone(timeZone)
          .toLocaleString(DateTime.DATETIME_SHORT)
      case 'local':
        return DateTime.fromISO(moment(date).toISOString()).toLocaleString(
          DateTime.DATETIME_SHORT,
        )
      default:
        return 'nothing selected'
    }
  }
  if (date === undefined) {
    return undefined
  }
  return <Box component="div">{returnValue()}</Box>
}
export default DisplayDate
